<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs  {{
		sectionclass
	}}"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="reach-freq-widget-header">
		<div class="campaignNameHeader">{{ sectiontitle }}</div>
		<a
			href="#"
			class="datatable_download_icon"
			*ngIf="hasData && downloadConfiguration && downloadConfiguration.enableDownload"
			(click)="downloadCSV()"
			target="_blank"
		>
			<img class="downloadIcon" src="../../../../../assets/creative-assets/download.svg" />
		</a>
	</div>
	<div *ngIf="hasData">
		<ngu-carousel #carousel [inputs]="carouselOne" (carouselLoad)="initDataFn($event)" [dataSource]="campaignsList">
			<ngu-tile NguCarouselItem class="col-xl-12" *nguCarouselDef="let campaign; let i = index">
				<div class="stats-container">
					<div *ngIf="!isR104" class="campaigns-toggle">
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="previous-arrow"
									(click)="prevArrow()"
									src="../../../../../assets/images/chevron-left-large.png"
								/>
							</a>
						</div>
						<div class="campaign-name">
							<p>{{ campaign.name }}</p>
						</div>
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="next-arrow"
									(click)="nextArrow()"
									src="../../../../../assets/images/chevron-right-large.svg"
								/>
							</a>
						</div>
					</div>
					<div *ngIf="isR104" class="campaigns-toggle">
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="previous-arrow"
									(click)="prevArrow()"
									src="../../../../../assets/creative-assets/arrow-left-r104.svg"
								/>
							</a>
						</div>
						<div class="campaign-name">
							<p>{{ campaign.name }}</p>
						</div>
						<div *ngIf="showToggleArrow" class="campaign-navigation-arrow">
							<a href="javascript:void(null)">
								<img
									class="next-arrow"
									(click)="nextArrow()"
									src="../../../../../assets/creative-assets/arrow-right-r104.svg"
								/>
							</a>
						</div>
					</div>

					<div class="campaign-content">
						<div class="campaign-data" [ngClass]="{ 'r4-loader-mask': showLoad }">
							<div class="lifetime-average">
								<div class="lifetime-average-title">Lifetime Campaign Average</div>

								<div *ngFor="let avg of campaign.averageLifetimes">
									<div class="lifetime-average-metric">
										<div class="metric-title">
											{{ avg.parameterName }}
										</div>
										<div class="metric-value" [ngClass]="{ 'normal-font-weight': avg.isNonZeroValue }">
											{{ avg.parameterValue }}
										</div>
									</div>
								</div>
							</div>
							<div class="lifetime-chart">
								<div *ngIf="campaign.showChart; else elseBlockHideChart" class="" style="min-height: 200px">
									<app-chart
										class="individual-chart"
										[setcolor]="customchartconfiguration.setGraphBackgroundColor"
										[chartData]="campaignCarouselItem"
									></app-chart>
								</div>
								<ng-template #elseBlockHideChart>
									<div class="individual-chart no-data">
										<p class="no-data-selected-date">{{ nodatamessage }}</p>
									</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</ngu-tile>
			<ul class="myPoint" NguCarouselPoint>
				<li
					*ngFor="let j of carousel.pointNumbers; let k = index"
					[class.primary-color-bg]="j == carousel.activePoint"
					(click)="moveToSelected(k)"
					[style.background]="'url(' + campaignsList[k] + ')'"
				></li>
			</ul>
		</ngu-carousel>
	</div>
	<div *ngIf="!hasData" class="no-reach-frequency">
		<div class="no-data-text">{{ nodatamessage }}</div>
	</div>
</div>
